<div #addbutton *ngxPermissionsOnly="['view.show.curate']">
	<p-splitButton label="{{this.defaultLabel}}" icon="pi pi-plus" [model]="containerAddTypes" (onClick)="addDefaultContainer()" [appendTo]="addbutton" data-element-id="app-content-components-container-add-splitbutton"></p-splitButton>
</div>
